
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface ExpertGuidanceSectionProps {
  visible: boolean;
}

const ExpertGuidanceSection = ({ visible }: ExpertGuidanceSectionProps) => {
  const navigate = useNavigate();

  return (
    <section className={`py-20 px-4 sm:px-6 md:px-8 bg-gradient-to-b from-white to-gray-50 transition-all duration-700 ease-in-out delay-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-6">
          Talk with Career Guidance Experts
        </h2>
        
        <p className="text-gray-700 mb-10 leading-relaxed">
          Choosing the right career path can be overwhelming, especially with so many options available after 10th and 12th grade. 
          Speaking with a career counselor helps you gain clarity, identify your strengths, and make informed decisions aligned with your skills and interests. 
          Our experienced experts provide personalized guidance based on your academic background, aspirations, and current industry trends. 
          Whether you're confused between streams, unsure about higher studies, or exploring new-age careers, a one-on-one session with a counselor can make all the difference in shaping your future.
        </p>
        
        <Button 
          onClick={() => navigate('/career-counselors')}
          variant="success" 
          size="lg"
          className="group font-semibold text-base shadow-md hover:shadow-lg transition-all"
        >
          Talk with Our Career Guidance Expert
          <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </Button>
      </div>
    </section>
  );
};

export default ExpertGuidanceSection;
